/**
 * Utility functions to manage video playback globally
 * This can be used from any component to stop video playback
 */

// Define interface for elements with ArtPlayer instance
interface ArtPlayerElement extends HTMLElement {
  __artplayer__?: {
    pause: () => void;
    destroy: () => void;
  };
}

/**
 * Stops all video playback in the application
 * This can be called from navigation events or other components
 */
export const stopAllVideoPlayback = () => {
  try {
    // Find and stop all video elements
    const videoElements = document.querySelectorAll('video');
    videoElements.forEach(video => {
      try {
        video.pause();
        video.src = '';
        video.load();
      } catch (err) {
        console.error('Error stopping video:', err);
      }
    });

    // Find and clean up any ArtPlayer instances
    const artPlayerContainers = document.querySelectorAll('.artplayer-app');
    artPlayerContainers.forEach(container => {
      try {
        // Try to access the Artplayer instance
        const playerElement = container as ArtPlayerElement;
        if (playerElement.__artplayer__ && typeof playerElement.__artplayer__.destroy === 'function') {
          playerElement.__artplayer__.pause();
          // We don't destroy here as that's handled by component unmounting
        }
      } catch (err) {
        console.error('Error accessing Artplayer instance:', err);
      }
    });

    // Clean up any HLS instances (this is approximate as they are not easily accessible)
    if (
      typeof window !== 'undefined' &&
      (window as any)['Hls'] &&
      typeof (window as any)['Hls'].instances === 'object'
    ) {
      const hlsInstances: Record<string, any> = (window as any)['Hls'].instances;
      Object.values(hlsInstances).forEach((hls: any) => {
        try {
          if (hls && typeof hls.destroy === 'function') {
            hls.destroy();
          }
        } catch (err) {
          console.error('Error destroying HLS instance:', err);
        }
      });
    }
  } catch (error) {
    console.error('Error in stopAllVideoPlayback:', error);
  }
};

export default {
  stopAllVideoPlayback
};
